import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Loader2, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { joinUrl } from "@/components/crew/joinLink";

const STEPS = ["Scan the code with your phone camera", "Create your login", "Install the app when asked"];

// Printable A4 poster with the join QR code, for the depot wall.
export default function JoinPoster() {
  const { code } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.joinInfo(code).then(setInfo).catch(() => setErr("This join link isn't valid any more.")); }, [code]);
  if (err) return <p className="p-10 text-center" data-testid="poster-invalid">{err}</p>;
  if (!info) return <div className="flex justify-center py-24"><Loader2 className="w-7 h-7 animate-spin" /></div>;
  return (
    <div className="min-h-screen bg-white text-[#0F172A] print:min-h-0" data-testid="join-poster">
      <div className="max-w-[720px] mx-auto px-8 py-10 print:py-4 flex flex-col items-center text-center">
        <Button onClick={() => window.print()} className="print:hidden mb-8 rounded-full" data-testid="poster-print-btn"><Printer className="w-4 h-4 mr-2" />Print poster</Button>
        <div className="w-full rounded-3xl px-8 py-7 text-white" style={{ background: info.color }}>
          {info.logo_url ? <img src={info.logo_url} alt="" className="mx-auto max-h-20 max-w-[260px] rounded-lg bg-white p-2" /> : <p className="font-display text-3xl font-extrabold">{info.company_name}</p>}
          <h1 className="font-display mt-5 text-5xl font-extrabold leading-tight" data-testid="poster-title">Join our crew</h1>
          <p className="mt-2 text-xl text-white/90">{info.company_name}{info.depot_name ? ` · ${info.depot_name}` : ""}</p>
        </div>
        <div className="mt-10 p-4 rounded-2xl border-4" style={{ borderColor: info.color }} data-testid="poster-qr"><QRCodeSVG value={joinUrl(code)} size={300} level="M" /></div>
        <ol className="mt-10 space-y-3 text-left text-xl">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-center gap-4">
              <span className="w-10 h-10 rounded-full text-white font-bold grid place-items-center shrink-0" style={{ background: info.color }}>{i + 1}</span>{s}
            </li>
          ))}
        </ol>
        <p className="mt-10 text-sm text-slate-500">No camera? Open <span className="font-mono text-slate-700" data-testid="poster-url">{joinUrl(code)}</span></p>
        <p className="mt-2 text-xs text-slate-400">Cross Jobs · jobs, shifts and timesheets for trade and service crews</p>
      </div>
    </div>
  );
}
